import { UserViewModel } from "../../viewmodels/setup/users/UserViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";
import MyAccountForm from "../../components/forms/my-account/MyAccountForm";
import MyPasswordForm from "../../components/forms/my-account/MyPasswordForm";
import EmptyModal from "../../components/modals/EmptyModal";

function MyAccount(props) {
  const { addSnackbar, email, logout, name, updateAccountDetails } = props;

  const {
    emptyModal,
    setEmptyModelOpen,

    updateAccountPassword,
  } = UserViewModel(addSnackbar, logout);

  return (
    <div>
      <div>
        <MyAccountForm
          updateAccountDetails={updateAccountDetails}
          userDetails={{
            name: name,
            email: email,
          }}
        />
      </div>
      <div>
        <MyPasswordForm updateAccountPassword={updateAccountPassword} />
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    name: state.auth.name,
    email: state.auth.email,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    updateAccountDetails: (payload) =>
      dispatch(actions.updateAccountDetails(payload)),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MyAccount),
);
